import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import EmptyNew from "@/components/EmptyNew.vue";
export default {
  name: "MemberClassesWare",
  components: {
    EmptyNew: EmptyNew
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      classifyId: 0,
      data: {
        classify: [],
        courseWare: []
      },
      records: []
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getChildren();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getChildren: function () {
      var _getChildren = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.get("/api/app/user/classCourseWare/" + this.id + "/");

              case 2:
                data = _context2.sent;
                data.courseWare.forEach(function (f) {
                  if (/\.(mp3|wav|wma|aac|flac|m4a|oga|opus|mp4|3gp|mpg|mpeg|3g2|avi|flv|wmv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(f.ware_url)) {
                    f.type = "video";
                  } else if (/\.(doc|docx)$/i.test(f.ware_url)) {
                    f.type = "word";
                  } else if (/\.(xls|xlsx)$/i.test(f.ware_url)) {
                    f.type = "excel";
                  } else if (/\.(pdf)$/i.test(f.ware_url)) {
                    f.type = "pdf";
                  } else if (/\.(ppt|pptx)$/i.test(f.ware_url)) {
                    f.type = "ppt";
                  } else if (/\.(zip)$/i.test(f.ware_url)) {
                    f.type = "zip";
                  } else {
                    f.type = "file";
                  }
                });
                this.data = data;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getChildren() {
        return _getChildren.apply(this, arguments);
      }

      return getChildren;
    }(),
    onFileClick: function onFileClick(file) {
      if (!file.ware_url) {
        return;
      }

      window.open(file.ware_url);
    },
    onPreview: function () {
      var _onPreview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(file) {
        var data, _data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(file.ware_type == 3)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return this.$http.get("/api/app/user/CourseWare/video/preview", {
                  video_id: file.fid
                });

              case 3:
                data = _context3.sent;
                window.open(data[0].url);
                _context3.next = 11;
                break;

              case 7:
                _context3.next = 9;
                return this.$http.get("/api/app/user/CourseWare/preview", {
                  fid: file.fid
                });

              case 9:
                _data = _context3.sent;
                window.open(_data);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onPreview(_x) {
        return _onPreview.apply(this, arguments);
      }

      return onPreview;
    }()
  }
};